import React from 'react';

const AuthComplate = () => {
  return (
    <div className="info_wrap Padding-20 pt-80">
      <ul className="step_box">
        <li className="comp">
          <span className="ico_step"></span>
          <div>정보입력</div>
        </li>
        <li className="comp">
          <span className="ico_step"></span>
          <div>카카오인증</div>
        </li>
        <li className="ing">
          <span className="ico_step"></span>
          <div>인증완료</div>
        </li>
      </ul>

      <div className="mt-100 align-c">
        <div>
          <img src="/assets/images/ico_success.svg" className="w-80" alt="성공 아이콘" />
        </div>
        <div className="mt-20 fs-20 fw-e">인증이 완료되었습니다.</div>

        <div className="mt-30 bg-eee fs-16 font-666 Padding-20 br-15 lh-24">
          분석이 완료되면
          <br />
          카카오 알림톡을 보내드리겠습니다.
        </div>
      </div>
    </div>
  );
};

export default AuthComplate;
